<template>
     <div class="site-view">
      <Header/>
      
 
        <section class="page-section">
       
            <div class="container">
                <div class="row">
                    <div class="col m12 l12">
                        <div class="text-wrap">
                            
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <TwoColumnFooter/>
        <Footer />
    </div>
</template>

<script>
import TwoColumnFooter from "@/components/belfast/TwoColumnFooter";


import Footer from "@/components/belfast/Footer";
import Header from "@/components/belfast/Header";
export default {
  name: "feedbackPage",
   components: {
    Header,
    Footer,
    TwoColumnFooter
  },
  data() {
    return {
       Title:"Feedback"
    }
  }
};
</script>
